export default {
  CUSTOM: "custom",
  POLICE: "police",
  MILITARY: "military",
  DIPLOMATIC_CMD: "diplomaticCMD",
  DIPLOMATIC_CD: "diplomaticCD",
  DIPLOMATIC_M: "diplomaticM",
}